import { Component, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ContactService } from '@app/core/services/contact.service';
import { ToastService } from '@app/core/services/toast.service';

@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent {
  contactForm = {
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  };

  submitted = false;
  loading = false;

  constructor(
    private contactService: ContactService,
    private toastService: ToastService,
    private cdr: ChangeDetectorRef
  ) {}

  onSubmit() {
    if (this.isFormValid()) {
      this.loading = true;
      // FRESH BUILD 17:16 - Force cache invalidation
      this.contactService.sendContactRequest(this.contactForm).subscribe({
        next: (response) => {
          console.log('🟢 FRISCHER BUILD 17:16 - Kontaktformular erfolgreich gesendet:', response);
          console.log('🟢 Setting submitted to TRUE');
          this.submitted = true;
          this.loading = false;
          console.log('✅ submitted is now:', this.submitted);          this.cdr.detectChanges(); // 🔥 Force Angular to update the view          this.toastService.show(response.message || 'Ihre Nachricht wurde erfolgreich versendet!', 'success');
          
          // Formular zurücksetzen nach 3 Sekunden
          setTimeout(() => {
            console.log('✅ Resetting form after 3 seconds');
            this.resetForm();
          }, 3000);
        },
        error: (error) => {
          console.error('Fehler beim Senden der Kontaktanfrage:', error);
          this.loading = false;
          this.toastService.show(
            error.error?.error || 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.',
            'error'
          );
        }
      });
    }
  }

  isFormValid(): boolean {
    return !!(
      this.contactForm.name &&
      this.contactForm.email &&
      this.contactForm.message
    );
  }

  resetForm() {
    this.contactForm = {
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: ''
    };
    this.submitted = false;
    this.loading = false;
  }
}
